/**
 * Static list of common suppliers for onboarding
 * This list can be updated and maintained independently
 */

export interface StaticSupplier {
  id: string;
  name: string;
  domains: string[];
}

export const STATIC_SUPPLIERS: StaticSupplier[] = [
  // Collaboration & Productivity
  { id: 'microsoft365', name: 'Microsoft 365', domains: ['microsoft.com'] },
  { id: 'googleworkspace', name: 'Google Workspace', domains: ['workspace.google.com'] },
  { id: 'slack', name: 'Slack', domains: ['slack.com'] },
  { id: 'zoom', name: 'Zoom', domains: ['zoom.us'] },
  { id: 'dropbox', name: 'Dropbox', domains: ['dropbox.com'] },
  { id: 'dropboxbusiness', name: 'Dropbox Business', domains: ['dropbox.com'] },
  { id: 'box', name: 'Box', domains: ['box.com'] },
  { id: 'boxbusiness', name: 'Box Business', domains: ['box.com'] },
  { id: 'notion', name: 'Notion', domains: ['notion.so'] },
  { id: 'asana', name: 'Asana', domains: ['asana.com'] },
  { id: 'trello', name: 'Trello', domains: ['trello.com'] },
  { id: 'monday', name: 'Monday.com', domains: ['monday.com'] },
  { id: 'clickup', name: 'ClickUp', domains: ['clickup.com'] },
  { id: 'basecamp', name: 'Basecamp', domains: ['basecamp.com'] },
  { id: 'smartsheet', name: 'Smartsheet', domains: ['smartsheet.com'] },
  { id: 'airtable', name: 'Airtable', domains: ['airtable.com'] },
  { id: 'coda', name: 'Coda', domains: ['coda.io'] },
  { id: 'miro', name: 'Miro', domains: ['miro.com'] },
  { id: 'figma', name: 'Figma', domains: ['figma.com'] },
  { id: 'lucidchart', name: 'Lucidchart', domains: ['lucidchart.com'] },
  { id: 'lucidspark', name: 'Lucidspark', domains: ['lucidspark.com'] },
  { id: 'confluence', name: 'Confluence', domains: ['atlassian.com'] },
  { id: 'microsoftteams', name: 'Microsoft Teams', domains: ['microsoft.com'] },
  { id: 'webex', name: 'Webex', domains: ['webex.com'] },
  { id: 'gotomeeting', name: 'GoToMeeting', domains: ['gotomeeting.com'] },
  { id: 'gotowebinar', name: 'GoToWebinar', domains: ['gotowebinar.com'] },
  { id: 'calendly', name: 'Calendly', domains: ['calendly.com'] },
  { id: 'docusign', name: 'DocuSign', domains: ['docusign.com'] },
  { id: 'adobesign', name: 'Adobe Acrobat Sign', domains: ['adobe.com'] },
  { id: 'hellosign', name: 'HelloSign', domains: ['hellosign.com'] },
  { id: 'pandadoc', name: 'PandaDoc', domains: ['pandadoc.com'] },
  { id: 'googledrive', name: 'Google Drive (Business)', domains: ['google.com'] },
  { id: 'onedrive', name: 'OneDrive for Business', domains: ['microsoft.com'] },
  { id: 'evernoteteams', name: 'Evernote Teams', domains: ['evernote.com'] },
  { id: 'surveymonkey', name: 'SurveyMonkey', domains: ['surveymonkey.com'] },
  { id: 'typeform', name: 'Typeform', domains: ['typeform.com'] },
  { id: 'jotform', name: 'Jotform', domains: ['jotform.com'] },

  // CRM & Sales
  { id: 'salesforcesales', name: 'Salesforce Sales Cloud', domains: ['salesforce.com'] },
  { id: 'salesforcemarketing', name: 'Salesforce Marketing Cloud', domains: ['salesforce.com'] },
  { id: 'salesforceservice', name: 'Salesforce Service Cloud', domains: ['salesforce.com'] },
  { id: 'salesforcehealth', name: 'Salesforce Health Cloud', domains: ['salesforce.com'] },
  { id: 'hubspotcrm', name: 'HubSpot CRM', domains: ['hubspot.com'] },
  { id: 'hubspotmarketing', name: 'HubSpot Marketing Hub', domains: ['hubspot.com'] },
  { id: 'hubspotservice', name: 'HubSpot Service Hub', domains: ['hubspot.com'] },
  { id: 'zohocrm', name: 'Zoho CRM', domains: ['zoho.com'] },
  { id: 'pipedrive', name: 'Pipedrive', domains: ['pipedrive.com'] },
  { id: 'freshsales', name: 'Freshsales', domains: ['freshworks.com'] },
  { id: 'insightly', name: 'Insightly', domains: ['insightly.com'] },
  { id: 'dynamics365', name: 'Microsoft Dynamics 365 Sales', domains: ['dynamics.microsoft.com'] },
  { id: 'sugarcrm', name: 'SugarCRM', domains: ['sugarcrm.com'] },
  { id: 'close', name: 'Close.com', domains: ['close.com'] },
  { id: 'copper', name: 'Copper', domains: ['copper.com'] },
  { id: 'salesloft', name: 'Salesloft', domains: ['salesloft.com'] },
  { id: 'outreach', name: 'Outreach', domains: ['outreach.io'] },
  { id: 'gong', name: 'Gong', domains: ['gong.io'] },
  { id: 'clari', name: 'Clari', domains: ['clari.com'] },
  { id: 'zendesksell', name: 'Zendesk Sell', domains: ['zendesk.com'] },
  { id: 'keap', name: 'Keap (Infusionsoft)', domains: ['keap.com'] },
  { id: 'nutshell', name: 'Nutshell', domains: ['nutshell.com'] },
  { id: 'nimble', name: 'Nimble', domains: ['nimble.com'] },

  // Marketing & Email
  { id: 'marketo', name: 'Marketo', domains: ['adobe.com'] },
  { id: 'pardot', name: 'Pardot', domains: ['salesforce.com'] },
  { id: 'mailchimp', name: 'Mailchimp', domains: ['mailchimp.com'] },
  { id: 'campaignmonitor', name: 'Campaign Monitor', domains: ['campaignmonitor.com'] },
  { id: 'activecampaign', name: 'ActiveCampaign', domains: ['activecampaign.com'] },
  { id: 'klaviyo', name: 'Klaviyo', domains: ['klaviyo.com'] },
  { id: 'constantcontact', name: 'Constant Contact', domains: ['constantcontact.com'] },
  { id: 'sendgrid', name: 'SendGrid', domains: ['sendgrid.com'] },
  { id: 'mailgun', name: 'Mailgun', domains: ['mailgun.com'] },
  { id: 'brevo', name: 'Brevo (Sendinblue)', domains: ['brevo.com'] },
  { id: 'braze', name: 'Braze', domains: ['braze.com'] },
  { id: 'iterable', name: 'Iterable', domains: ['iterable.com'] },
  { id: 'customerio', name: 'Customer.io', domains: ['customer.io'] },
  { id: 'getresponse', name: 'GetResponse', domains: ['getresponse.com'] },
  { id: 'convertkit', name: 'ConvertKit', domains: ['convertkit.com'] },
  { id: 'drip', name: 'Drip', domains: ['drip.com'] },
  { id: 'mailjet', name: 'Mailjet', domains: ['mailjet.com'] },

  // Customer Support
  { id: 'zendesk', name: 'Zendesk', domains: ['zendesk.com'] },
  { id: 'freshdesk', name: 'Freshdesk', domains: ['freshworks.com'] },
  { id: 'intercom', name: 'Intercom', domains: ['intercom.com'] },
  { id: 'helpscout', name: 'Help Scout', domains: ['helpscout.com'] },
  { id: 'servicenow', name: 'ServiceNow Customer Service', domains: ['servicenow.com'] },
  { id: 'zohodesk', name: 'Zoho Desk', domains: ['zoho.com'] },
  { id: 'livechat', name: 'LiveChat', domains: ['livechat.com'] },
  { id: 'drift', name: 'Drift', domains: ['drift.com'] },
  { id: 'crisp', name: 'Crisp', domains: ['crisp.chat'] },
  { id: 'tidio', name: 'Tidio', domains: ['tidio.com'] },
  { id: 'front', name: 'Front', domains: ['front.com'] },
  { id: 'gladly', name: 'Gladly', domains: ['gladly.com'] },

  // User Research & Analytics
  { id: 'usertesting', name: 'UserTesting', domains: ['usertesting.com'] },
  { id: 'hotjar', name: 'Hotjar', domains: ['hotjar.com'] },
  { id: 'fullstory', name: 'FullStory', domains: ['fullstory.com'] },

  // Finance & Accounting
  { id: 'quickbooks', name: 'QuickBooks Online', domains: ['quickbooks.intuit.com'] },
  { id: 'xero', name: 'Xero', domains: ['xero.com'] },
  { id: 'myob', name: 'MYOB', domains: ['myob.com'] },
  { id: 'sageintacct', name: 'Sage Intacct', domains: ['sageintacct.com'] },
  { id: 'netsuite', name: 'Oracle NetSuite', domains: ['netsuite.com'] },
  { id: 'freshbooks', name: 'FreshBooks', domains: ['freshbooks.com'] },
  { id: 'wave', name: 'Wave Accounting', domains: ['waveapps.com'] },
  { id: 'zohobooks', name: 'Zoho Books', domains: ['zoho.com'] },
  { id: 'bill', name: 'Bill.com', domains: ['bill.com'] },
  { id: 'airwallex', name: 'Airwallex', domains: ['airwallex.com'] },
  { id: 'wise', name: 'Wise Business', domains: ['wise.com'] },
  { id: 'stripebilling', name: 'Stripe Billing', domains: ['stripe.com'] },
  { id: 'chargebee', name: 'Chargebee', domains: ['chargebee.com'] },
  { id: 'zuora', name: 'Zuora', domains: ['zuora.com'] },
  { id: 'recurly', name: 'Recurly', domains: ['recurly.com'] },
  { id: 'expensify', name: 'Expensify', domains: ['expensify.com'] },
  { id: 'concur', name: 'SAP Concur', domains: ['concur.com'] },
  { id: 'brex', name: 'Brex', domains: ['brex.com'] },
  { id: 'ramp', name: 'Ramp', domains: ['ramp.com'] },

  // HR & Payroll
  { id: 'workday', name: 'Workday', domains: ['workday.com'] },
  { id: 'adp', name: 'ADP Workforce Now', domains: ['adp.com'] },
  { id: 'successfactors', name: 'SAP SuccessFactors', domains: ['sap.com'] },
  { id: 'bamboohr', name: 'BambooHR', domains: ['bamboohr.com'] },
  { id: 'gusto', name: 'Gusto', domains: ['gusto.com'] },
  { id: 'rippling', name: 'Rippling', domains: ['rippling.com'] },
  { id: 'hibob', name: 'HiBob', domains: ['hibob.com'] },
  { id: 'deel', name: 'Deel', domains: ['deel.com'] },
  { id: 'remote', name: 'Remote.com', domains: ['remote.com'] },
  { id: 'employmenthero', name: 'Employment Hero', domains: ['employmenthero.com'] },
  { id: 'paylocity', name: 'Paylocity', domains: ['paylocity.com'] },
  { id: 'paycom', name: 'Paycom', domains: ['paycom.com'] },
  { id: 'zenefits', name: 'Zenefits', domains: ['zenefits.com'] },
  { id: 'namely', name: 'Namely', domains: ['namely.com'] },
  { id: 'personio', name: 'Personio', domains: ['personio.com'] },

  // Recruiting & Talent
  { id: 'greenhouse', name: 'Greenhouse', domains: ['greenhouse.io'] },
  { id: 'lever', name: 'Lever', domains: ['lever.co'] },
  { id: 'smartrecruiters', name: 'SmartRecruiters', domains: ['smartrecruiters.com'] },
  { id: 'jobadder', name: 'JobAdder', domains: ['jobadder.com'] },
  { id: 'workable', name: 'Workable', domains: ['workable.com'] },

  // Performance & Engagement
  { id: 'cultureamp', name: 'Culture Amp', domains: ['cultureamp.com'] },
  { id: '15five', name: '15Five', domains: ['15five.com'] },
  { id: 'lattice', name: 'Lattice', domains: ['lattice.com'] },

  // Identity & Access Management
  { id: 'okta', name: 'Okta', domains: ['okta.com'] },
  { id: 'azuread', name: 'Azure Active Directory (Entra ID)', domains: ['microsoft.com'] },
  { id: 'jumpcloud', name: 'JumpCloud', domains: ['jumpcloud.com'] },
  { id: 'onelogin', name: 'OneLogin', domains: ['onelogin.com'] },
  { id: 'auth0', name: 'Auth0', domains: ['auth0.com'] },
  { id: 'duo', name: 'Duo Security', domains: ['duo.com'] },
  { id: '1password', name: '1Password', domains: ['1password.com'] },
  { id: 'lastpass', name: 'LastPass', domains: ['lastpass.com'] },
  { id: 'bitwarden', name: 'Bitwarden', domains: ['bitwarden.com'] },

  // Security & Compliance
  { id: 'crowdstrike', name: 'CrowdStrike', domains: ['crowdstrike.com'] },
  { id: 'sentinelone', name: 'SentinelOne', domains: ['sentinelone.com'] },
  { id: 'carbonblack', name: 'Carbon Black', domains: ['carbonblack.com'] },
  { id: 'prisma', name: 'Palo Alto Prisma Access', domains: ['paloaltonetworks.com'] },
  { id: 'zscaler', name: 'Zscaler', domains: ['zscaler.com'] },
  { id: 'fortinet', name: 'Fortinet FortiSASE', domains: ['fortinet.com'] },
  { id: 'cloudflarezero', name: 'Cloudflare Zero Trust', domains: ['cloudflare.com'] },
  { id: 'mimecast', name: 'Mimecast', domains: ['mimecast.com'] },
  { id: 'proofpoint', name: 'Proofpoint', domains: ['proofpoint.com'] },
  { id: 'knowbe4', name: 'KnowBe4', domains: ['knowbe4.com'] },
  { id: 'tenable', name: 'Tenable.io', domains: ['tenable.com'] },
  { id: 'qualys', name: 'Qualys', domains: ['qualys.com'] },
  { id: 'rapid7', name: 'Rapid7 Insight', domains: ['rapid7.com'] },

  // Monitoring & Observability
  { id: 'splunkcloud', name: 'Splunk Cloud', domains: ['splunk.com'] },
  { id: 'splunkobs', name: 'Splunk Observability Cloud', domains: ['splunk.com'] },
  { id: 'datadog', name: 'Datadog', domains: ['datadoghq.com'] },
  { id: 'newrelic', name: 'New Relic', domains: ['newrelic.com'] },
  { id: 'pagerduty', name: 'PagerDuty', domains: ['pagerduty.com'] },
  { id: 'opsgenie', name: 'Opsgenie', domains: ['atlassian.com'] },

  // IT Service Management
  { id: 'servicenowitsm', name: 'ServiceNow ITSM', domains: ['servicenow.com'] },
  { id: 'jirasm', name: 'Jira Service Management', domains: ['atlassian.com'] },
  { id: 'ninjaone', name: 'NinjaOne', domains: ['ninjaone.com'] },
  { id: 'jamf', name: 'Jamf', domains: ['jamf.com'] },
  { id: 'kandji', name: 'Kandji', domains: ['kandji.io'] },
  { id: 'intune', name: 'Microsoft Intune', domains: ['microsoft.com'] },
  { id: 'datto', name: 'Datto RMM', domains: ['datto.com'] },
  { id: 'kaseya', name: 'Kaseya VSA', domains: ['kaseya.com'] },

  // Data & Analytics
  { id: 'snowflake', name: 'Snowflake', domains: ['snowflake.com'] },
  { id: 'databricks', name: 'Databricks', domains: ['databricks.com'] },
  { id: 'bigquery', name: 'Google BigQuery', domains: ['cloud.google.com'] },
  { id: 'redshift', name: 'Amazon Redshift', domains: ['aws.amazon.com'] },
  { id: 'synapse', name: 'Azure Synapse', domains: ['azure.microsoft.com'] },
  { id: 'tableau', name: 'Tableau Cloud', domains: ['tableau.com'] },
  { id: 'looker', name: 'Looker', domains: ['cloud.google.com'] },
  { id: 'powerbi', name: 'Power BI Pro', domains: ['powerbi.microsoft.com'] },
  { id: 'qlik', name: 'Qlik Cloud', domains: ['qlik.com'] },
  { id: 'domo', name: 'Domo', domains: ['domo.com'] },
  { id: 'mode', name: 'Mode Analytics', domains: ['mode.com'] },
  { id: 'sigma', name: 'Sigma Computing', domains: ['sigmacomputing.com'] },
  { id: 'amplitude', name: 'Amplitude', domains: ['amplitude.com'] },
  { id: 'mixpanel', name: 'Mixpanel', domains: ['mixpanel.com'] },
  { id: 'heap', name: 'Heap', domains: ['heap.io'] },
  { id: 'segment', name: 'Segment', domains: ['segment.com'] },
  { id: 'rudderstack', name: 'RudderStack', domains: ['rudderstack.com'] },
  { id: 'logrocket', name: 'LogRocket', domains: ['logrocket.com'] },
  { id: 'sentry', name: 'Sentry', domains: ['sentry.io'] },
  { id: 'elastic', name: 'Elastic Cloud', domains: ['elastic.co'] },

  // Development & DevOps
  { id: 'github', name: 'GitHub', domains: ['github.com'] },
  { id: 'gitlab', name: 'GitLab', domains: ['gitlab.com'] },
  { id: 'bitbucket', name: 'Bitbucket', domains: ['bitbucket.org'] },
  { id: 'azuredevops', name: 'Azure DevOps', domains: ['azure.microsoft.com'] },
  { id: 'jira', name: 'Jira Software', domains: ['atlassian.com'] },
  { id: 'linear', name: 'Linear', domains: ['linear.app'] },
  { id: 'circleci', name: 'CircleCI', domains: ['circleci.com'] },
  { id: 'travisci', name: 'Travis CI', domains: ['travis-ci.com'] },
  { id: 'githubactions', name: 'GitHub Actions', domains: ['github.com'] },
  { id: 'harness', name: 'Harness', domains: ['harness.io'] },
  { id: 'jenkinsx', name: 'Jenkins X', domains: ['jenkins.io'] },
  { id: 'cloudbees', name: 'CloudBees CI', domains: ['cloudbees.com'] },
  { id: 'launchdarkly', name: 'LaunchDarkly', domains: ['launchdarkly.com'] },
  { id: 'snyk', name: 'Snyk', domains: ['snyk.io'] },
  { id: 'veracode', name: 'Veracode', domains: ['veracode.com'] },
  { id: 'sonarcloud', name: 'SonarCloud', domains: ['sonarcloud.io'] },
  { id: 'postman', name: 'Postman', domains: ['postman.com'] },
  { id: 'insomnia', name: 'Insomnia', domains: ['insomnia.rest'] },
  { id: 'datadogapm', name: 'Datadog APM', domains: ['datadoghq.com'] },
  { id: 'newrelicapm', name: 'New Relic APM', domains: ['newrelic.com'] },

  // E-commerce & Retail
  { id: 'shopify', name: 'Shopify', domains: ['shopify.com'] },
  { id: 'shopifypos', name: 'Shopify POS', domains: ['shopify.com'] },
  { id: 'bigcommerce', name: 'BigCommerce', domains: ['bigcommerce.com'] },
  { id: 'magento', name: 'Magento Commerce Cloud', domains: ['adobe.com'] },
  { id: 'woocommerce', name: 'WooCommerce.com (hosted services)', domains: ['woocommerce.com'] },
  { id: 'wix', name: 'Wix', domains: ['wix.com'] },
  { id: 'squarespace', name: 'Squarespace', domains: ['squarespace.com'] },
  { id: 'lightspeed', name: 'Lightspeed', domains: ['lightspeedhq.com'] },
  { id: 'lightspeedretail', name: 'Lightspeed Retail', domains: ['lightspeedhq.com'] },
  { id: 'square', name: 'Square Online', domains: ['squareup.com'] },

  // Payments
  { id: 'stripe', name: 'Stripe', domains: ['stripe.com'] },
  { id: 'paypal', name: 'PayPal', domains: ['paypal.com'] },
  { id: 'adyen', name: 'Adyen', domains: ['adyen.com'] },
  { id: 'braintree', name: 'Braintree', domains: ['braintreepayments.com'] },
  { id: 'afterpay', name: 'Afterpay', domains: ['afterpay.com'] },
  { id: 'tyro', name: 'Tyro', domains: ['tyro.com'] },
  { id: 'tyropayments', name: 'Tyro Payments', domains: ['tyro.com'] },
  { id: 'recharge', name: 'ReCharge', domains: ['rechargepayments.com'] },
  { id: 'rechargepayments', name: 'Recharge Payments', domains: ['rechargepayments.com'] },
  { id: 'bolt', name: 'Bolt', domains: ['bolt.com'] },
  { id: 'fastspring', name: 'FastSpring', domains: ['fastspring.com'] },
  { id: 'paddle', name: 'Paddle', domains: ['paddle.com'] },
  { id: 'gocardless', name: 'GoCardless', domains: ['gocardless.com'] },
  { id: 'square_payments', name: 'Square Payments', domains: ['squareup.com'] },
  { id: 'worldpay', name: 'Worldpay', domains: ['worldpay.com'] },
  { id: 'checkout', name: 'Checkout.com', domains: ['checkout.com'] },
  { id: 'klarna', name: 'Klarna', domains: ['klarna.com'] },
  { id: 'affirm', name: 'Affirm', domains: ['affirm.com'] },
  { id: 'zip', name: 'Zip', domains: ['zip.co'] },

  // Cloud Infrastructure
  { id: 'aws', name: 'Amazon Web Services', domains: ['aws.amazon.com'] },
  { id: 'googlecloud', name: 'Google Cloud Platform', domains: ['cloud.google.com'] },
  { id: 'azure', name: 'Microsoft Azure', domains: ['azure.microsoft.com'] },
  { id: 'cloudflare', name: 'Cloudflare', domains: ['cloudflare.com'] },
  { id: 'vercel', name: 'Vercel', domains: ['vercel.com'] },
  { id: 'netlify', name: 'Netlify', domains: ['netlify.com'] },
  { id: 'heroku', name: 'Heroku', domains: ['heroku.com'] },
  { id: 'digitalocean', name: 'DigitalOcean', domains: ['digitalocean.com'] },
  { id: 'linode', name: 'Linode', domains: ['linode.com'] },
  { id: 'vultr', name: 'Vultr', domains: ['vultr.com'] },
  { id: 'ovhcloud', name: 'OVHcloud', domains: ['ovhcloud.com'] },
  { id: 'ibmcloud', name: 'IBM Cloud', domains: ['ibm.com'] },
  { id: 'oraclecloud', name: 'Oracle Cloud', domains: ['oracle.com'] },
  { id: 'alibabacloud', name: 'Alibaba Cloud', domains: ['alibabacloud.com'] },
  { id: 'render', name: 'Render', domains: ['render.com'] },
  { id: 'railway', name: 'Railway', domains: ['railway.app'] },
  { id: 'fly', name: 'Fly.io', domains: ['fly.io'] },
];
